// extracted by mini-css-extract-plugin
export default {"recommendedPlan":"ULrX6S"};